import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .directive('minutesToDaysModel', minutesToDaysModel);

function minutesToDaysModel() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attrs, ngModel) => {

      // Model → View (minutes → days)
      ngModel.$formatters.push(function(modelValue) {
        if (modelValue == null) return modelValue;
        return Math.floor(modelValue / (60 * 24)); // convert minutes → days
      });

    }
  };
}
